<template>
    <div class="hello">

        <div style="text-align: center">
            <img src="../assets/titel.jpg" id="titel" style="width: 100%;">
        </div>
        <div class="desc">
            <template v-if="language=='de'">

                <h2>Zwei Länder - ein Park - interaktiv Erleben</h2>

                <p>
                    Diese App entstand im Rahmen des Projekts Brückenpark (2016-2019) und soll junge und ältere Besucher
                    neugierig machen, den Brückenpark zu entdecken. Die App will Orientierung geben, Sehenswürdigkeiten
                    zeigen und Hintergründe erläutern. Den kurzen Informationen Parkteilen und Wegpunkten sind
                    Quizfragen angefügt, deren Beantwortung mit Punkten honoriert wird. Entscheidend ist, die richtige
                    Antwort möglichst schnell einzugeben!<br>
                    Die App wird stetig vervollständigt und ergänzt. Für Hinweise und Kritiken sind die Verfasser und
                    Programmierer dankbar. Stadtverwaltung Görlitz, Amt für Stadtentwicklung
                </p>
            </template>
            <template v-if="language=='pl'">

                <h2>dwa państwa - jeden park</h2>
                <p>

                    Aplikacja powstała w ramach projektu Park Mostów (2016-2019), aby zachęcić młodsze i starsze osoby
                    do poznania Parku Mostów. Przy pomocy aplikacji chcemy ułatwić orientację, pokazać ciekawe miejsca i
                    przekazać informacje o nich. Do krótkich opisów o poszczególnych miejscach w parku i punktach
                    orientacyjnych dołączone są pytania kwizu, a odpowiedzi na nie są nagradzane punktami. Decyduje czas
                    zaznaczenia prawidłowej odpowiedzi! <br>
                    Aplikacja jest stale poszerzana i uzupełniana. Autorzy i
                    programiści są wdzięczni za wskazówki i opinie.
                    Urząd Miasta Görlitz, Wydział Rozwoju Miasta

                </p>
            </template>
        </div>
    </div>
</template>

<script type="text/babel">

    export default {
        name: 'HelloWorld',

        computed: {
            language: function () {
                return this.$root.$i18n.locale;
            }
        }
    }
</script>

<style scoped lang="scss">
    .desc {
        h2 {
            margin-bottom: 15px;
            margin-top: 30px;
        }

        padding: 30px;


        margin-right: 30px;
        margin-left: 30px;
        margin-top: -30px;
        z-index: 99;
        position: relative;
        @media screen and (max-width: 480px) {
            padding: 15px;
            margin-right: 15px;
            margin-left: 15px;
        }
    }
</style>
